/* eslint-disable prettier/prettier */
// packages
import { widont } from 'journalize';
import { Component, h } from 'preact';

// components
import GranicusViewer from './components/GranicusViewer';
import StreamTab from './components/StreamTab';

// internal
import { HOUSE_CAMERA_ID, SENATE_CAMERA_ID } from './constants';

import { checkFeed } from './utils/detect-cameras';

class App extends Component {
  constructor() {
    super();

    this.state = {
      selectedStream: 'house',
      houseInfo: '',
      senateInfo: '',
      houseIsLive: true,
      senateIsLive: true,
    };

    this.onStreamToggle = this.onStreamToggle.bind(this);
    // this.update = this.update.bind(this);
  }

  onStreamToggle(selectedStream) {
    if (this.state.selectedStream !== selectedStream) {
      this.setState({ selectedStream });
    }
  }

  componentDidMount() {
    // this.update();
  }

  // This calls the files created to see if a camera is on
  // may not use for the 87th session
  async update() {
                   // const [camera_status] = await Promise.all([
                   //   checkFeed('house', HOUSE_CAMERA_ID),
                   //   checkFeed('senate', SENATE_CAMERA_ID),
                   // ]);
                   // this.setState(
                   //   {
                   //     houseIsLive: camera_status.house,
                   //     senateIsLive: camera_status.senate,
                   //   },
                   //   () => (this.timer = setTimeout(this.update, 1000 * 60 * 3))
                   // );
                 }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const {
      selectedStream,
      houseInfo,
      senateInfo,
      houseIsLive,
      senateIsLive,
    } = this.state;

    const streamClass = `embed-responsive embed-responsive--16x9 stream-placeholder stream-placeholder--${selectedStream}`;

    const buildURL = path => `${process.env.PUBLIC_PATH}${path}`;
    const backgroundImage =
      'background-image: url(' +
      buildURL('assets/images/' + selectedStream + '-placeholder.gif') +
      ')';

    return (
      <div class="app">
        <div class="video-nav">
          <StreamTab
            stream="house"
            label="Texas House"
            info={houseInfo}
            isActive={selectedStream === 'house'}
            isLive={houseIsLive}
            onClick={this.onStreamToggle}
          />
          <StreamTab
            stream="senate"
            label="Texas Senate"
            info={senateInfo}
            isActive={selectedStream === 'senate'}
            isLive={senateIsLive}
            onClick={this.onStreamToggle}
          />
        </div>
        <div>
          {selectedStream === 'house' && houseIsLive && (
            <div class={streamClass} style={backgroundImage}>
              <GranicusViewer
                subdomain="tlchouse"
                params={{ camera_id: HOUSE_CAMERA_ID, autostart: 1, embed: 1 }}
              />
            </div>
          )}
          {selectedStream === 'senate' && senateIsLive && (
            <div class={streamClass} style={backgroundImage}>
              <GranicusViewer
                subdomain="tlcsenate"
                params={{ camera_id: SENATE_CAMERA_ID, autostart: 1, embed: 1 }}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default App;
